

































































































import { Component } from 'vue-property-decorator';

import { mixins } from 'vue-class-component';
import MainMenuGroupingMixin from '@/views/layout/navigation/mixins/main-menu-grouping-mixin';


@Component
export default class MainMenuGroupingDesktop extends mixins(MainMenuGroupingMixin) {}
